module.exports = __webpack_public_path__ + "static/joan-robinson-44fd574605fdcad11bb5b19e49c9bf4e.jpg";